import { Routes } from "@angular/router";
import { ProductListComponent } from "../../components/product-list/product-list.component";
import {HomeComponent} from "../../features/admin/home/home.component";
import {UnauthorizedComponent} from "../../features/auth/unauthorized/unauthorized.component";
import {FirstPageComponent} from "../../components/simple-page/first-page/first-page.component";
import {SecondPageComponent} from "../../components/simple-page/second-page/second-page.component";
import {ProfileComponent} from "../../features/client/profile/profile.component";
import {NewComponent} from "../../features/service/new/new.component";
import {BacklogComponent} from "../../features/service/backlog/backlog.component";
import {EmployeeComponent} from "../../features/admin/employee/employee.component";
import {RolComponent} from "../../features/admin/rol/rol.component";
import {UserComponent} from "../../features/admin/user/user.component";
import {CategoryComponent} from "../../features/vehicles/category/category.component";
import {VehicleComponent} from "../../features/vehicles/vehicle/vehicle.component";
import {CanceledComponent} from "../../features/service/canceled/canceled.component";
import {ListComponent} from "../../features/service/list/list.component";
import {EventComponent} from "../../features/service/event/event.component";
import {TaskComponent} from "../../features/task/task.component";
import {DashboardComponent} from "../../features/vehicles/dashboard/dashboard.component";
import {MovementsComponent} from "../../features/vehicles/movements/movements.component";
import {InspectionComponent} from "../../features/vehicles/inspection/inspection.component";
import {InspectionBoardComponent} from "../../features/vehicles/inspection/inspection-board.component";
import {MaintenanceBoardComponent} from "../../features/vehicles/maintenance/maintenance-board.component";
import {EmpresaComponent} from "../../features/admin/empresa/empresa.component";

export const content: Routes = [
    {
        path: '',
        component: HomeComponent,
        data: {
            title: "Bienvenido",
            breadcrumb: "Bienvenido",
            module: "home"
        }
    },
    {
        path: 'home',
        component: HomeComponent,
        data: {
            title: "Bienvenido",
            breadcrumb: "Bienvenido",
            module: "home"
        }
    },
    {
        path: 'unauthorized',
        component: UnauthorizedComponent,
        data: {
            title: "Sin autorización",
            breadcrumb: "Sin autorización",
            module: "home"
        }
    },
    {
        path: 'admin',
        loadChildren: () => import('../../features/admin/admin.routes'),
        data: {
            title: "admin",
            breadcrumb: "Admin",
            module: "rol_admin"
        }
    },
    {
        path: 'vehicle',
        children: [
            {
                path: "management",
                component: VehicleComponent,
                data: {
                    title: 'Gestión de vehículos',
                    breadcrumb: 'gestión',
                    module: 'Gestión'
                }
            },
            {
                path: "category",
                component: CategoryComponent,
                data: {
                    title: 'Categoría de vehículos',
                    breadcrumb: 'categoría',
                    module: 'Categoría'
                }
            },
            {
                path: "dashboard",
                component: DashboardComponent,
                data: {
                    title: 'Vehículos',
                    breadcrumb: 'vehículos',
                    module: 'Vehículos'
                }
            },
            {
                path: "movements",
                component: MovementsComponent,
                data: {
                    title: 'Entradas y Salidas',
                    breadcrumb: 'Movimientos',
                    module: 'Entradas y Salidas'
                }
            },
            {
                path: "inspection",
                component: InspectionBoardComponent,
                data: {
                    title: 'Hoja de inspección',
                    breadcrumb: 'Hoja de inspección',
                    module: 'Hoja de inspección'
                }
            },
            {
                path: "maintenance",
                component: MaintenanceBoardComponent,
                data: {
                    title: 'Mantenimiento',
                    breadcrumb: 'mantenimiento',
                    module: 'Mantenimiento'
                }
            }
        ],
        data: {
            title: "admin",
            breadcrumb: "Admin",
            module: "rol_admin"
        }
    },
    {
      path: 'profile',
      children:[
        {
            path: "client",
            component: ProfileComponent,
            data: {
                title: 'Perfil',
                breadcrumb: 'Perfil',
                module: "rol_client"
            }
        }
      ],
      data: {
        title: "Perfil",
        breadcrumb: "Perfil",
          module: "rol_client"
      }
    },
    {
      path: 'service',
      children:[
        {
            path: "new",
            component: NewComponent,
            data: {
                title: 'Nuevo servicio',
                breadcrumb: 'servicio',
                module: "rol_client"
            }
        },
      ],
      data: {
        title: 'Cotizar/Reservar',
        breadcrumb: 'Cotizar/Reservar',
        module: 'rol_client'
      }
    },
    {
        path: 'service',
        children:[
            {
                path: "backlog",
                component: BacklogComponent,
                data: {
                    title: 'BackLog',
                    breadcrumb: 'BackLog',
                    module: "Backlog"
                }
            }, {
                path: "canceled",
                component: CanceledComponent,
                data: {
                    title: 'Cancelados',
                    breadcrumb: 'Cancelados',
                    module: "Cancelados"
                }
            }, {
                path: "list",
                component: ListComponent,
                data: {
                    title: 'Servicios',
                    breadcrumb: 'Servicios',
                    module: "Servicios"
                }
            }, {
                path: "event",
                component: EventComponent,
                data: {
                    title: 'Eventos',
                    breadcrumb: 'Eventos',
                    module: "Eventos"
                }
            }, {
                path: "task",
                component: TaskComponent,
                data: {
                    title: 'Tareas',
                    breadcrumb: 'Tareas',
                    module: "Tareas"
                }
            }, {
                path: "company",
                component: EmpresaComponent,
                data: {
                    title: 'Empresas',
                    breadcrumb: 'Empresas',
                    module: "Empresas"
                }
            }
        ],
        data: {
            title: 'Servicio',
            breadcrumb: 'Servicio',
            module: 'rol_admin'
        }
    }
  ]
  
